module.exports = __webpack_public_path__ + "static/media/shark-finished.6e1e9882.png";